import React, { useState, useEffect } from "react";
import { TabsPane, TabPaneStyled } from "./styles";
import { NoData } from "../../../../../../CommonComponents/commonStyles";
import TabContent from "./TabContent";
import { Blocks } from "../RenderTable/style";
import  PropTypes from 'prop-types';


export default function TabsComponent(props) {
  const {
    tabContent,
    styling,
    singleData,
    recurringData,
    agreementsData,
    update,
    updateRec,
    highlighter,
    setPrinter,
    handleColumnChange,
    getDataSource
  } = props;
  const [activeKey, setActiveKey] = useState(
    props.tabIndex ? props.tabIndex : "1"
  );

  useEffect(() => {
    setOptions();
  }, []);

  useEffect(() => {
    overideTab();
  }, [activeKey]);

  const overideTab = () => props.tabIndex && setActiveKey(props.tabIndex);
  const setOptions = () => {
    const { singleData, agreementsData, recurringData } = props;
    let otStatus = [];
    let reStatus = [];
    let gaStatus = [];
    let reFrequency = [];
    let grantFilters = {};
    let scheduleFilters = {};
    let agreementFilters = {};

    //Grants Status
    if (singleData && singleData.singleGrants.length) {
      grantFilters.status = Object.values(singleData.availbleStatus);
    }
    //Recurring Status and Frequency
    if (recurringData && recurringData.recurringGrant.length) {
      recurringData.recurringGrant.forEach(each => {
        if (reStatus.indexOf(each.status) < 0) {
          reStatus.push(each.status);
        }
        if (reFrequency.indexOf(each.frequency) < 0) {
          reFrequency.push(each.frequency);
        }
      });
      scheduleFilters.status = reStatus;
      scheduleFilters.frequency = reFrequency;
    }
    //Agreement Status
    if (agreementsData && agreementsData.length) {
      agreementsData.forEach(each => {
        if (gaStatus.indexOf(each.status.description) < 0) {
          gaStatus.push(each.status.description);
        }
      });
      agreementFilters.status = gaStatus;
    }

    const isGrants = !!grantFilters.status ? !!grantFilters.status : true;
    const isSchedules = !!(scheduleFilters.status && scheduleFilters.frequency)
      ? !!(scheduleFilters.status && scheduleFilters.frequency)
      : true;
    const isAgreements = !!agreementFilters.status;

    if (isGrants && isSchedules && isAgreements) {
      return { grantFilters, scheduleFilters, agreementFilters };
    } else if (isGrants && isSchedules) {
      return { grantFilters, scheduleFilters };
    }
  };

  const handleChange = activeKey => {
    setActiveKey(activeKey);
    props.getChange && props.getChange(activeKey);
  };

  return (
    <>
      <TabsPane defaultActiveKey={activeKey} onChange={handleChange}>
        {tabContent().grants && (
          <TabPaneStyled
            tab={`${tabContent().grants.title}`}
            key={`${tabContent().grants.key}`}
            className={`primary ${styling}`}
          >
            {singleData && !singleData.singleGrants.length && (
              <Blocks flex center h={100}>
                <NoData>{tabContent().grants.text}</NoData>
              </Blocks>
            )}
           
            {singleData && singleData.singleGrants  && (
              <TabContent
                className="grantsTab"
                data={singleData.singleGrants}
                column={tabContent().grants.columnConfig}
                text={tabContent().grants.text}
                card={"GrantCard"}
                options={setOptions().grantFilters}
                tab={activeKey}
                tabKey={tabContent().grants.key}
                highlightThis={highlighter}
                setPrinter={setPrinter}
                handleChange={ (sorter, extra) => handleColumnChange(sorter, extra) }
                getDataSource={(currentData)=> getDataSource(currentData)}
              />
            )}
          </TabPaneStyled>
        )}

        {/** Grant Schedules Tab */}
        {tabContent().schedules && (
          <TabPaneStyled
            tab={`${tabContent().schedules.title}`}
            key={`${tabContent().schedules.key}`}
            className={`primary ${styling}`}
          >
           
             {recurringData && recurringData.recurringGrant && ! recurringData.recurringGrant.length && (
              <Blocks flex center h={100}>
              <NoData>{tabContent().schedules.text}</NoData>
            </Blocks>
            )}
          {recurringData &&  recurringData.recurringGrant && recurringData.recurringGrant.length &&  (
              <TabContent
              className="grantsSchedule"
              data={recurringData.recurringGrant}
              column={tabContent().schedules.columnConfig}
              text={tabContent().schedules.text}
              card={"RecurringCard"}
              options={setOptions().scheduleFilters}
              tab={activeKey}
              tabKey={tabContent().schedules.key}
              highlightThis={highlighter}
              setPrinter={setPrinter}
              handleChange={ (sorter, extra) => handleColumnChange(sorter, extra) }
              getDataSource={(currentData)=> getDataSource(currentData)}
            />
            )}

         


            {/* {recurringData && recurringData.recurringGrant.length ? (
              <TabContent
                className="grantsSchedule"
                data={recurringData.recurringGrant}
                column={tabContent().schedules.columnConfig}
                text={tabContent().schedules.text}
                card={"RecurringCard"}
                options={setOptions().scheduleFilters}
                tab={activeKey}
                tabKey={tabContent().schedules.key}
                highlightThis={highlighter}
                setPrinter={setPrinter}
                handleChange={ (sorter, extra) => handleColumnChange(sorter, extra) }
                getDataSource={(currentData)=> getDataSource(currentData)}
              />
            ) : (checkUpdate
              <Blocks flex center h={100}>
                <NoData>{tabContent().schedules.text}</NoData>
              </Blocks>
            )} */}
          </TabPaneStyled>
        )}

        {/** Grant Agreements Tab */}
        {tabContent().agreements && agreementsData && agreementsData.length && (
          <TabPaneStyled
            tab={`${tabContent().agreements.title}`}
            key={`${tabContent().agreements.key}`}
            className={`primary ${styling}`}
          >
            {agreementsData && agreementsData.length ? (
              <TabContent
                className="grantsAgreement"
                data={agreementsData}
                column={tabContent().agreements.columnConfig}
                text={tabContent().agreements.text}
                card={"Agreements"}
                options={setOptions().agreementFilters}
                tab={activeKey}
                tabKey={tabContent().agreements.key}
                highlightThis={highlighter}
                setPrinter={setPrinter}
                handleChange={ (sorter, extra) => handleColumnChange(sorter, extra) }
                getDataSource={(currentData)=> getDataSource(currentData)}
              />
            ) : (
              <Blocks flex center h={100}>
                <NoData>{tabContent().agreements.text}</NoData>
              </Blocks>
            )}
          </TabPaneStyled>
        )}
      </TabsPane>
    </>
  );

  }

TabsComponent.propTypes = {
  tabContent: PropTypes.func,
  tabController: PropTypes.func,
  userData: PropTypes.object,
  highlighter: PropTypes.func,
  grantTab: PropTypes.string,
  checkUpdate: PropTypes.func,
  checkUpdateRec: PropTypes.func,
  setPrinter: PropTypes.func,
  handleColumnChange: PropTypes.func,
  getDataSource: PropTypes.func
}
